import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/ShootApi/';
export const getShootingArea = (data)=>{
  return getInterface.post(`${prefixUrl}getShootingArea`, data);
}
export const applyAreaImage = (data)=>{
  return getInterface.post(`${prefixUrl}applyAreaImage`, data);
}
export const queryAreaImageList = (data)=>{
  return getInterface.post(`${prefixUrl}queryAreaImageList`, data);
}
export const getAuthUrlById = (data)=>{
  return getInterface.post(`${prefixUrl}getAuthUrlById/${data}`, data);
}